export const EMPLOYER_STATUSES = {
  'rest': 'не работает',
  'work': 'на заказе',
  'free': 'свободен'
};
